<template>
  <v-card class="elevation-5 mb-4 px-2 py-3">
    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg12>
          <v-layout row wrap>
            <v-flex d-flex lg8 xs12>
              <h1 class="grey--text subheading mt-1 pt-2 text--darken-1">
                Guia Nº {{ guiaDetalhe.numeroGuia }}
              </h1>
            </v-flex>
            <v-flex d-flex lg4 xs12>
              <v-layout lg2 row wrap justify-end>
                <v-flex d-flex lg6 xs12>
                  <v-btn light color="grey lighten-2" @click="voltar"
                    >Voltar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider></v-divider>

    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg12>
          <v-expansion-panel expand class="elevation-0 pt-4" v-model="panel">
            <v-expansion-panel-content class="elevation-5 mb-3">
              <template v-slot:header>
                <div class="title">Informações da Guia</div>
              </template>
              <v-card>
                <v-card-text class="px-4">
                  <v-layout row wrap class="my-2">
                    <v-flex lg4 xs12>
                      <div class="font-weight-bold">Status da guia</div>
                      <div>
                        {{ guiaDetalhe.descricaoSituacao || "Não informado" }}
                      </div>
                    </v-flex>

                    <v-flex
                      lg4
                      xs8
                      v-if="hasCartaNegativa || hasStatusCartaNegativa"
                    >
                      <div class="font-weight-bold">
                        Status carta de negativa
                      </div>
                      <div>
                        {{ cartaNegativaGuiaStatus || "Não informado" }}
                      </div>
                    </v-flex>

                    <v-flex
                      lg4
                      xs8
                      v-if="!hasCartaNegativa || !hasStatusCartaNegativa"
                    >
                      <div class="font-weight-bold">Senha</div>
                      <div>{{ guiaDetalhe.senha || "Não informado" }}</div>
                    </v-flex>
                    <v-flex
                      lg4
                      xs12
                      v-if="!hasCartaNegativa || !hasStatusCartaNegativa"
                    >
                      <div class="font-weight-bold">Data validade senha</div>
                      <div>
                        {{ guiaDetalhe.dataValidadeSenha || "Não informado" }}
                      </div>
                    </v-flex>
                    <v-flex lg4 xs12 v-if="hasCartaNegativa">
                      <v-btn
                        dark
                        class="white--text"
                        color="primary"
                        @click="baixar"
                        v-if="showBtn"
                      >
                        Baixar carta de negativa
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="my-2">
                    <v-flex lg4 xs12>
                      <div class="font-weight-bold">Caráter</div>
                      <div>
                        {{ guiaDetalhe.caraterSolicitacao || "Não informado" }}
                      </div>
                    </v-flex>

                    <v-flex lg4 xs12>
                      <div class="font-weight-bold">Tipo de solicitação</div>
                      <div>
                        {{ guiaDetalhe.tipoSolicitacao || "Não informado" }}
                      </div>
                    </v-flex>

                    <v-flex lg4 xs12>
                      <div class="font-weight-bold">Data de solicitação</div>
                      <div>
                        {{ guiaDetalhe.dataSolicitacao || "Não informado" }}
                      </div>
                    </v-flex>
                  </v-layout>

                  <!-- Clínica -->
                  <v-layout row wrap class="my-2">
                    <v-flex lg4 xs12>
                      <div class="font-weight-bold">Unimed Executora</div>
                      <div>{{ guiaDetalhe.unimedId || "Não informado" }}</div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
      <loading-dialog
        :show="isLoading"
        :message="loadingMessage"
      ></loading-dialog>
    </v-container>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { cartaNegativaStatus } from "./service";
const portalStore = createNamespacedHelpers("portal");
const beneficiarioStore = createNamespacedHelpers("beneficiario");
import { baixarCartaNegativa } from "./service";
import { download } from "@/utils/download";
import LoadingDialog from "@/components/LoadingDialog";

export default {
  name: "GuiaDetalhe",
  props: {
    guiaDetalhe: Object
  },
  components: {
    LoadingDialog
  },
  data() {
    return {
      arrayCartaNegativaStatus: {
        pending: "Pendente",
        sended: "Enviado",
        automaticSended: "Enviado automaticamente",
        canceled: "Cancelada",
        running: "Em execução"
      },
      panel: [true],
      showBtn: false,
      cartaNegativaGuiaStatus: null,
      exibirDetalheGuia: true,
      hasCartaNegativa: false,
      hasStatusCartaNegativa: false,
      statusCartaNegativa: false,
      loadingMessage: "Aguarde, carregando!",
      isLoading: false
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    }
  },
  async created() {
    await this.getCartaNegativaStatus();
  },
  methods: {
    ...portalStore.mapMutations(["setErrorToast", "setToast"]),
    baixar() {
      const payload = {
        codigoBeneficiario: this.codigoBeneficiario,
        numeroGuia: this.guiaDetalhe.numeroGuia
      };

      baixarCartaNegativa(payload)
        .then(({ headers, data }) => {
          const filename = headers["content-disposition"].replace(
            "attachment; filename=",
            ""
          );

          download(data, filename);
        })
        .catch(({ response }) => {
          if (response?.data?.error) {
            const errorMessage = response?.data?.message;

            this.setToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
    voltar() {
      this.$emit("voltar");
    },
    getCartaNegativaStatus() {
      this.isLoading = true;
      const payload = {
        codigoBeneficiario: this.codigoBeneficiario,
        numeroGuia: this.guiaDetalhe.numeroGuia
      };

      cartaNegativaStatus(payload)
        .then(response => {
          this.cartaNegativaGuiaStatus = this.arrayCartaNegativaStatus[
            response.data.operationStatus
          ];
          this.hasCartaNegativa = true;
          this.hasStatusCartaNegativa = true;
          if (response.data.permiteDownload) {
            this.showBtn = true;
          }
        })
        .catch(() => {
          this.showBtn = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
